// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type {
  GetUserSessionsChatSessionsGetQueryResponse,
  GetUserSessionsChatSessionsGetQueryParams,
  GetUserSessionsChatSessionsGet422,
} from "../models/chatController/GetUserSessionsChatSessionsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getGetUserSessionsChatSessionsGetUrl() {
  const res = { method: "GET", url: `/chat/sessions` as const };
  return res;
}

/**
 * @description Get user's chat sessions
 * @summary Get User Sessions
 * {@link /chat/sessions}
 */
export async function getUserSessionsChatSessionsGet(
  params?: GetUserSessionsChatSessionsGetQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserSessionsChatSessionsGetQueryResponse,
    ResponseErrorConfig<GetUserSessionsChatSessionsGet422>,
    unknown
  >({
    method: "GET",
    url: getGetUserSessionsChatSessionsGetUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
